const snikhiyEndpointConfig = {
    httpEndpoint: 'https://awf1fq943a.execute-api.us-west-2.amazonaws.com/prod',
    cognitoIdentityPoolId: 'us-west-2:c320e408-4821-451b-b29f-e2441f7af92f',
    region: 'us-west-2',
};

const cpAnalyticsEnpointConfig = {
    httpEndpoint: 'https://339j6ps1sg.execute-api.us-west-2.amazonaws.com/prod',
    cognitoIdentityPoolId: 'us-west-2:d99f5b04-d8bc-4913-836f-02b788cc46d6',
    region: 'us-west-2'
}

const costCorrectionEnpointConfig = {
    httpEndpoint: 'https://aqg76fk7oe.execute-api.us-west-2.amazonaws.com/prod',
    cognitoIdentityPoolId: 'us-west-2:45038983-4a9b-43d8-a583-c03f5528a28d',
    region: 'us-west-2'
}

export function getSelfServiceEndpointConfig() {
    const url = window.location.hostname;
    switch(url) {
        case 'localhost.a2z.com':
            return costCorrectionEnpointConfig;
        case 'tools-oghaneka.profit-intelligence.selling-partners.a2z.com':
            return costCorrectionEnpointConfig;
        case 'tools-alpha.profit-intelligence.selling-partners.a2z.com':
            return cpAnalyticsEnpointConfig;
        case 'phoenix.profit-intelligence.selling-partners.a2z.com':
            return cpAnalyticsEnpointConfig;
        case 'tools.profit-intelligence.selling-partners.a2z.com':
            return cpAnalyticsEnpointConfig;
        default:
            throw new Error(`No endpoint configured for ${url}`);
    }
}


// WEBPACK FOOTER //
// ./src/components/spotlight/spotcp-self-service-endpoint-configs.js